import styled from 'styled-components';

export const Container = styled.div`
  .control {
    font-family: arial;
    position: relative;
    padding-left: 20px;
    margin-bottom: 0;
    margin-right: 0;
    padding-top: 0;
    cursor: pointer;
  }
  .control input {
    position: absolute;
    z-index: -1;
    opacity: 0;
  }
  .control_indicator {
    position: absolute;
    top: 3px;
    left: 0;
    height: 1rem;
    width: 1rem;
    background: transparent;
    border: 1px solid ${(props) => props.theme.$gray600};
    border-radius: 3px;
  }
  .control:hover input ~ .control_indicator,
  .control input:focus ~ .control_indicator {
    border-color: ${(props) => props.theme.$primary};
    background: transparent;
  }

  .control input:checked ~ .control_indicator {
    background: ${(props) => props.theme.$primary};
    border-color: ${(props) => props.theme.$primary};
  }

  .control input:disabled ~ .control_indicator {
    background: ${(props) => props.theme.$bg_gray};
    opacity: 0.6;
    pointer-events: none;
  }
  .control_indicator:after {
    box-sizing: unset;
    content: '';
    position: absolute;
    display: none;
  }
  .control input:checked ~ .control_indicator:after {
    display: block;
  }
  .control-checkbox .control_indicator:after {
    left: 0.3rem;
    top: 0.01rem;
    width: 3px;
    height: 8px;
    border: solid ${(props) => props.theme.$white};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
  }
  .control-checkbox input:disabled ~ .control_indicator:after {
    border-color: ${(props) => props.theme.$gray600};
  }
  .control-checkbox .control_indicator::before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 4.5rem;
    height: 4.5rem;
    margin-left: -1.3rem;
    margin-top: -1.3rem;
    background: ${(props) => props.theme.$primary};
    border-radius: 3rem;
    opacity: 0.6;
    z-index: 99999;
    transform: scale(0);
  }
  @keyframes s-ripple {
    0% {
      transform: scale(0);
    }
    20% {
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
  }
  @keyframes s-ripple-dup {
    0% {
      transform: scale(0);
    }
    30% {
      transform: scale(1);
    }
    60% {
      transform: scale(1);
    }
    100% {
      opacity: 0;
      transform: scale(1);
    }
  }
  .control-checkbox input + .control_indicator::before {
    animation: s-ripple 250ms ease-out;
  }

  .control-checkbox input:checked + .control_indicator::before {
    animation-name: s-ripple-dup;
  }

  .control.checkbox-danger {
    input ~ .control_indicator,
    input:focus ~ .control_indicator {
      border-color: ${(props) => props.theme.$danger};
      background: transparent;
    }

    input:checked ~ .control_indicator {
      background: ${(props) => props.theme.$danger};
      border-color: ${(props) => props.theme.$danger};
    }
  }

  .control.checkbox-purple {
    input ~ .control_indicator,
    input:focus ~ .control_indicator {
      border-color: ${(props) => props.theme.$purple};
      background: transparent;
    }

    input:checked ~ .control_indicator {
      background: ${(props) => props.theme.$purple};
      border-color: ${(props) => props.theme.$purple};
    }
  }

  .control.checkbox-orange {
    input ~ .control_indicator,
    input:focus ~ .control_indicator {
      border-color: ${(props) => props.theme.$light_orange};
      background: transparent;
    }

    input:checked ~ .control_indicator {
      background: ${(props) => props.theme.$light_orange};
      border-color: ${(props) => props.theme.$light_orange};
    }
  }

  .control.checkbox-brown {
    input ~ .control_indicator,
    input:focus ~ .control_indicator {
      border-color: ${(props) => props.theme.$brown};
      background: transparent;
    }

    input:checked ~ .control_indicator {
      background: ${(props) => props.theme.$brown};
      border-color: ${(props) => props.theme.$brown};
    }
  }

  .control.checkbox-warning {
    input ~ .control_indicator,
    input:focus ~ .control_indicator {
      border-color: ${(props) => props.theme.$warning};
      background: transparent;
    }

    input:checked ~ .control_indicator {
      background: ${(props) => props.theme.$warning};
      border-color: ${(props) => props.theme.$warning};
    }

    .control_indicator:after {
      border-color: #000000;
    }
  }

  .control.checkbox-info {
    input ~ .control_indicator,
    input:focus ~ .control_indicator {
      border-color: ${(props) => props.theme.$info};
      background: transparent;
    }

    input:checked ~ .control_indicator {
      background: ${(props) => props.theme.$info};
      border-color: ${(props) => props.theme.$info};
    }
  }

  .control.checkbox-success {
    input ~ .control_indicator,
    input:focus ~ .control_indicator {
      border-color: ${(props) => props.theme.$success};
      background: transparent;
    }

    input:checked ~ .control_indicator {
      background: ${(props) => props.theme.$success};
      border-color: ${(props) => props.theme.$success};
    }
  }
`;
